import { render, staticRenderFns } from "./TagsSearch.vue?vue&type=template&id=6a20c124&"
import script from "./TagsSearch.vue?vue&type=script&lang=js&"
export * from "./TagsSearch.vue?vue&type=script&lang=js&"
import style0 from "./TagsSearch.vue?vue&type=style&index=0&id=6a20c124&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports